import { useQuery } from "@tanstack/react-query";
import articleFetch from "Api/articles/fetch";

export function useFetchArticle(slug: string) {
  const query = () => articleFetch(slug);

  return useQuery(["articlesFetch", slug], query);
}
